<script context="module">

</script>


<script>
export let registration;
export let jersey_form_changes;
export let team_instance_id;
export let conference_id;

console.log(conference_id);

// has_options ?
export let jersey_numbers_options; // 0 - 99 (Yes).

export let jersey_size_option;
export let jersey_sizes_players;
export let jersey_sizes_goalies;

export let socks_size_option;
export let socks_sizes_players;
export let socks_sizes_goalies;


export let jerseys_form_deadline;


export let last_year_jerseys_socks_info;



import { auth } from 'store/index.js';
import { get } from 'svelte/store';


import { onMount } from 'svelte';
import tippy from 'sveltejs-tippy';
import dayjs from 'dayjs';


import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();


let saving = false;
let changes_to_be_saved = false;


let now = dayjs();
// with proper tz!


const excluded_team_instance_ids = [278, 568];
const overdue = ((dayjs().isAfter(dayjs(jerseys_form_deadline))) && (!excluded_team_instance_ids.includes(team_instance_id)) );

console.log(dayjs().isAfter(dayjs(jerseys_form_deadline)));
console.log(jerseys_form_deadline);
console.log(overdue);


let invalid = false;

let invalid_jersey_number = false;
let invalid_jersey_size = false;
let invalid_socks_size = false;


let invalid_message;


// Jerseys

let is_duplicate_jersey_number;
let is_invalid_jersey_number;
let is_invalid_jersey_size;
let is_overflow_jersey_size;



// Socks

let is_invalid_socks_size;




let last_year_order = last_year_jerseys_socks_info.find( ({ player_id }) => player_id === registration.player_id);


// Jerseys

let jersey_number = '';
if ((last_year_order) && ([1,4].contains(conference_id))) {

	if (last_year_order.jersey_number !== null) {
		jersey_number = last_year_order.jersey_number;
	}

} else {

	if (registration.jersey_number !== null) {
		jersey_number = registration.jersey_number;
	}

}


let jersey_size = '';
if ((last_year_order) && ([1,4].contains(conference_id))) {

	jersey_size = last_year_order.jersey_size || '';

} else {
	jersey_size = registration.jersey_size || '';
}



// Socks

let socks_size = '';
if (last_year_order) {

	socks_size = last_year_order.socks_size || '';

} else {
	socks_size = registration.socks_size || '';
}




// $: {
// 	jersey_number = formatJerseyNumber();
// }

// $: {
// 	jerse 
// }



// bad code...
// on change is sooooo much better....
$: {

	// Really only jersey_form_changes !! What matters is acting on those changes.

	jersey_number = formatJerseyNumber();
	jersey_size = formatJerseySize();
	socks_size = formatSocksSize();


	is_invalid_jersey_number = isInvalidJerseyNumber();
	is_invalid_jersey_size = isInvalidJerseySize();
	is_duplicate_jersey_number = isDuplicateJerseyNumber(jersey_form_changes);
	is_overflow_jersey_size = isOverflowJerseySize(jersey_form_changes);

	is_invalid_socks_size = isInvalidSocksSize();



	invalid_jersey_number = (is_invalid_jersey_number || is_duplicate_jersey_number);
	invalid_jersey_size = (is_invalid_jersey_size || is_overflow_jersey_size);
	invalid_socks_size = (is_invalid_socks_size);



	invalid = (invalid_jersey_number || invalid_jersey_size || invalid_socks_size);


	changes_to_be_saved = (
		(
			(jersey_number !== initial_jersey_number) || 
			(jersey_size !== initial_jersey_size) || 
			(socks_size !== initial_socks_size)
		) && 
		!invalid
	);


	jersey_form_changes[`${registration.id}`] = {'changes_to_be_saved': changes_to_be_saved, 'jersey_number': jersey_number, 'jersey_size': jersey_size, 'socks_size': socks_size, 'position': registration.position};

}




let player_name = registration.player.first_name + ' ' + registration.player.last_name;

let is_goalie_position = (registration.position === 'goalie');

let no_goalie_choice_freedom = (jersey_sizes_goalies.length === 1);
let no_goalie_choice_freedom_size_value = (jersey_sizes_goalies[0]['size_value']);
let no_goalie_choice_freedom_size_name = (jersey_sizes_goalies[0]['size_name']);


if ((is_goalie_position) && (no_goalie_choice_freedom) && (registration.needs_jersey)) {
	jersey_size = no_goalie_choice_freedom_size_value;
}



let initial_jersey_number = jersey_number;
let initial_jersey_size = jersey_size;

let initial_socks_size = socks_size;


const api_url = app_.env.API_URL;

const token = get(auth).token;


const save_jersey_disabled_props = {
	content: 'Make valid changes to jersey number or size to save!',
	placement: 'bottom',
	arrow: false,
};

const save_jersey_active_props = {
	content: 'Click to save jersey changes!',
	placement: 'bottom',
	arrow: false,
};

const invalid_props = {
	// theme: 'hidden',
	content: 'Invalid! duplicated or improper number',
	placement: 'bottom',
	arrow: false,
}




let needs_new_jersey = registration.needs_jersey;
let needs_new_socks = registration.needs_socks;

if (needs_new_jersey === null) {
	needs_new_jersey = true;
}
if (needs_new_socks === null) {
	needs_new_socks = true;
}





// will be removed !!



// Jersey

function formatJerseyNumber() {
	jersey_number = jersey_number.toString().replace(/\D/g,'');
	if (jersey_number === '') return jersey_number;

	// 00 -> 0, 01 -> 1 ... !
	jersey_number = parseInt(jersey_number);

	return jersey_number;
}

function formatJerseySize() {
	// Not sure what to do ?
	return jersey_size;
}



// Socks

function formatSocksSize() {
	// Not sure what to do ?
	return socks_size;
}






function saveJerseySocksInfo() {

	// alert(team_instance_id);
	saving = true;

	let jersey_number_data = jersey_number;
	if (jersey_number === '') {
		jersey_number_data = null;
	}

	let jersey_size_data = jersey_size;
	if (jersey_size === '') {
		jersey_size_data = null;
	}

	let socks_size_data = socks_size;
	if (socks_size === '') {
		socks_size_data = null;
	}


	let body_data = JSON.stringify({ 'jersey_number': jersey_number_data, 'jersey_size': jersey_size_data, 'socks_size': socks_size_data, });

	submitJerseySocksInfo(body_data).then(data => {

		if (data.jersey_number === null) {
			initial_jersey_number = '';
		} else {
			initial_jersey_number = data.jersey_number;
		}

		if (data.jersey_size === null) {
			initial_jersey_size = '';
		} else {
			initial_jersey_size = data.jersey_size;
		}

		if (data.socks_size === null) {
			initial_socks_size = '';
		} else {
			initial_socks_size = data.socks_size;
		}


		dispatch('jersey_socks_saved_msg', {
			msg: `Saved jersey form for ${player_name}!`,
			type: 'success',
		});


	}).catch(err => {

		dispatch('jersey_socks_saved_msg', {
			msg: `Error saving jersey form for ${player_name}`,
			type: 'error',
		});

	}).finally(() => {

		saving = false;

	});

}


async function submitJerseySocksInfo(body_data) {

	const url = `${api_url}coaches/team-instance/${team_instance_id}/registration/${registration.id}/jersey`;

	const resp = await fetch(url, {
		method: 'PUT',
		body: body_data,
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	});

	const result = await resp.json();

	if (!resp.ok) {
		throw new Error(result.detail);
	}

	return result;

}




// Jersey validation.

function isInvalidJerseyNumber() {
	if (jersey_number === '') return false;
	return ((!Number.isInteger(jersey_number)) || (!jersey_numbers_options.includes(jersey_number)));
}


function isInvalidJerseySize() {
	if (jersey_size === '') return false;
	if (is_goalie_position) {
		try {
			return (!(jersey_sizes_goalies.map(item => item.size_value)).includes(jersey_size));
		} catch(e) {
			return false;
		}
	} else { // player
		try {
			return (!(jersey_sizes_players.map(item => item.size_value)).includes(jersey_size));
		} catch(e) {
			return false;
		}
	}
}


function isDuplicateJerseyNumber(jersey_form_changes) {
	if (jersey_number === '') return false;
	for (var key of Object.keys(jersey_form_changes)) {
		if (parseInt(key) === registration.id) continue;
		if (jersey_form_changes[key]['jersey_number'] === jersey_number) return true;
	}
	return false;
}


// players -- goalies differential.
function isOverflowJerseySize(jersey_form_changes) {
	if (jersey_size === '') return false;
	
	let size_count = 0;
	let max_size_count;

	if (is_goalie_position) {

		for (var value of Object.values(jersey_form_changes)) {
			if ((value['jersey_size'] === jersey_size) && (value['position'] === 'goalie')) size_count += 1;
		}
		let size_index = (jersey_sizes_goalies.map(item => item.size_value)).indexOf(jersey_size);
		try {
			max_size_count = jersey_sizes_goalies[size_index]['number'];
			if (max_size_count === 'i') return false; // No limit baby!
		} catch(e) {
			return false;
		} finally {

		}

	} else {

		for (var value of Object.values(jersey_form_changes)) {
			if ((value['jersey_size'] === jersey_size) && (value['position'] !== 'goalie')) size_count += 1;
		}
		let size_index = (jersey_sizes_players.map(item => item.size_value)).indexOf(jersey_size);
		try {
			max_size_count = jersey_sizes_players[size_index]['number'];
			if (max_size_count === 'i') return false; // no limit baby!
		} catch(e) {
			return false;
		} finally {

		}

	}

	return size_count > max_size_count;
}



// Socks

function isInvalidSocksSize() {
	if (socks_size === '') return false;
	if (is_goalie_position) {
		try {
			return (!(socks_sizes_goalies.map(item => item.size_value)).includes(socks_size));
		} catch(e) {
			return false;
		}
	} else { // player
		try {
			return (!(socks_sizes_players.map(item => item.size_value)).includes(socks_size));
		} catch(e) {
			return false;
		}
	}
}


</script>



<style>

.jersey-number-thumb {

}

.jersey-number-thumb {

}

.input {
	height: 2rem;
}

span.icon {
	height: 2rem;
	width: 2rem;
	color: #d65050 !important;
}

.invalid .input {
	border-color: #c71e1e !important;
	color: #d65050 !important;
}


select.invalid {
	border-color: #c71e1e !important;
	color: #d65050 !important;
}



:global(.tippy-tooltip) {
	background: blue !important;
}

.invalid .tippy-tooltip {
	display: block;
}

.select {
	height: 2rem;
}

.select select {
	height: 2rem;
	padding-top: calc(0.25rem - 1px);
    padding-bottom: calc(0.25rem - 1px);
}


.message-text {
	color: #5a5a5a;
}


@media (max-width: 1024px) {
	.control.has-icons-right .input {
		padding-right: 0rem;
	}
}


</style>



<div class="panel-block jersey-number-thumb">

	<div class="columns is-variable is-mobile is-2 is-vcentered">


		<div class="column is-3-desktop is-3-touch">
			<span>
				{player_name}
				{#if is_goalie_position}(G){/if}
			</span>
		</div>


		<div class="column is-1-desktop is-2-touch">

			<div class="field" class:invalid={invalid_jersey_number}>

				<div class="control has-icons-right">

					<input class="input jersey-number" type="text" placeholder="#" maxlength="2" bind:value={jersey_number} disabled={saving | overdue | (!!last_year_order & !!jersey_number)}>

					{#if invalid_jersey_number}
					<span class="icon is-small is-right is-hidden-touch">
						<i class="far fa-times-circle"></i>
					</span>
					{/if}

				</div>

			</div>

		</div>


		<!-- Seperator -->
		<div class="column is-1-desktop is-hidden-touch"></div>


		<div class="column is-2-desktop is-2-touch">

			{#if jersey_size_option}

				{#if needs_new_jersey}

				<div class="select jersey-size">
					<select bind:value={jersey_size} disabled={saving | (no_goalie_choice_freedom & is_goalie_position) | overdue | (!!last_year_order & !!jersey_size)} class:invalid={invalid_jersey_size}>
						<option value="">Size</option>
						{#if is_goalie_position}
							{#if no_goalie_choice_freedom}
								<!-- tippy...? -->
								<option value="{no_goalie_choice_freedom_size_value}">{no_goalie_choice_freedom_size_name}</option>
							{:else}
								{#each jersey_sizes_goalies as size}
									<option value="{size.size_value}">{size.size_name}</option>
								{/each}
							{/if} 
						{:else}
							{#each jersey_sizes_players as size}
								<option value="{size.size_value}">{size.size_name}</option>
							{/each}
						{/if}
					</select>
				</div>

				{:else}

				<p class="message-text">Has Jersey</p>

				{/if}

			{/if}

		</div>


		<div class="column is-2-desktop is-2-touch">

			{#if socks_size_option}

				{#if needs_new_socks}

				<div class="select socks-size">

					<select bind:value={socks_size} disabled={saving | overdue | (!!last_year_order & !!socks_size)} class:invalid={invalid_socks_size}>
						<option value="">Size</option>
						{#each socks_sizes_players as size}
							<option value="{size.size_value}">{size.size_name}</option>
						{/each}
					</select>

				</div>

				{:else}

				<p class="message-text">Has Socks</p>

				{/if}

			{/if}

		</div>


		<div class="column is-3-desktop is-3-touch">
			<div class="columns is-mobile is-0 is-variable is-vcentered">
				<div class="column">

				</div>
				<div class="column is-narrow">

					{#if !changes_to_be_saved | saving | overdue}
					<span use:tippy={save_jersey_disabled_props}>
						<span class="button is-blue is-small" disabled>
							{#if !saving}<span class="is-hidden-mobile">Save Changes</span><span class="is-hidden-desktop is-hidden-tablet">Save</span>{:else}Saving{/if}
							<i class="fas fa-circle-notch fa-spin" class:is-hidden={!saving}></i>
						</span>
					</span>
					{:else}
					<span use:tippy={save_jersey_active_props}>
						<span class="button is-blue is-small" type="submit" on:click={saveJerseySocksInfo}>
							<span class="is-hidden-mobile">Save Changes</span><span class="is-hidden-desktop is-hidden-tablet">Save</span>
						</span>
					</span>
					{/if}

				</div>
			</div>

		</div>



	</div>

</div>



